import { RouteRecordRaw } from 'vue-router';
import { Layout } from '@/router/constant';
import { TableOutlined } from '@vicons/antd';
import { Template, Result } from '@vicons/carbon';
import { CloudUploadOutline } from '@vicons/ionicons5';
import { renderIcon } from '@/utils/index';

/**
 * @param name 路由名称, 必须设置,且不能重名
 * @param meta 路由元信息（路由附带扩展信息）
 * @param redirect 重定向地址, 访问这个路由时,自定进行重定向
 * @param meta.disabled 禁用整个菜单
 * @param meta.title 菜单名称
 * @param meta.icon 菜单图标
 * @param meta.keepAlive 缓存该路由
 * @param meta.permissions 配置系统权限, 缺省开放所有权限
 * @param meta.sort 排序越小越排前
 * @param meta.hidden 从菜单中隐藏
 * @param meta.alwaysShow 总是显示菜单
 * @param meta.isRoot 单级菜单
 * */
const routes: Array<RouteRecordRaw> = [
  {
    path: '/bulk',
    name: 'bulk',
    redirect: '/bulk/templates',
    component: Layout,
    meta: {
      title: 'Bulk',
      icon: renderIcon(TableOutlined),
      permissions: ['bulk_templates_read', 'bulk_upload_read'],
      sort: 7.5,
    },
    children: [
      {
        path: 'templates',
        name: 'bulk_templates',
        meta: {
          title: 'Templates',
          spname: 'bulk_excel_template',
          icon: renderIcon(Template),
          permissions: ['bulk_templates_read'],
        },
        component: () => import('@/views/bulk/templates/index.vue'),
      },
      {
        path: 'upload',
        name: 'bulk_upload',
        meta: {
          title: 'Upload',
          spname: 'excel_execution_result',
          icon: renderIcon(CloudUploadOutline),
          permissions: ['bulk_upload_read'],
        },
        component: () => import('@/views/bulk/upload/index.vue'),
      },
      // {
      //   path: 'results',
      //   name: 'results',
      //   meta: {
      //     title: 'Results',
      //     spname: 'excel_execution_result',
      //     icon: renderIcon(Result),
      //     //配置该路由需要哪些权限可访问 这里是针对单个路由
      //     // permissions: ['purchasing_invoice_read'],
      //   },
      //   component: () => import('@/views/bulk/results/index.vue'),
      // },
    ],
  },
];

export default routes;
